<template>
  <section class="section">
    <div class="container">
      <div class="box is-hidden-touch zoom">
        <a :href="urlHomeCreate">
          <figure class="image">
            <img src="@/assets/img/promo/promo_banner.png">
          </figure>
        </a>
      </div>
      <div class="box is-hidden-desktop zoom">
        <a :href="urlHomeCreate">
          <figure class="image">
            <img src="@/assets/img/promo/promo_banner_touch.png">
          </figure>
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .zoom {
    transition: transform .2s;
  }
  .zoom:hover {
    transform: scale(1.05);
  }
</style>

<script>
export default {
  name: 'Promo',
  data () {
    return {
      urlHomeCreate: process.env.VUE_APP_URL_CREATE_HOME
    }
  }
}
</script>
